import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBn0DF15y5yFOEXgCfZpElAMK1rOC98IeE",
  authDomain: "selfhelpsnaps.firebaseapp.com",
  projectId: "selfhelpsnaps",
  storageBucket: "selfhelpsnaps.appspot.com",
  messagingSenderId: "889631698412",
  appId: "1:889631698412:web:6d8762610c6587030de4c9",
  measurementId: "G-TKXM9T6RX0",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
